import {   FETCH_ACTIVE_SEASONS,SAVE_SEASON_SETUP,TRIGGER_SEASON,RESET_SETUP_SETTINGS  } from '../../actions'

function getSeasonsSetup(seasons){
       
        const seasonSetup = {}
      
        seasons.map(function(season) {
      
          const { id, minT1games, minT2games, bakerToStandardGamesRatio, maxEventDuration, tierOneGameMaxThreshold,
                  totalGameMaxThreshold,isSeasonSet } = season
            const setup = {
                seasonId: id,
                minT1games,
                minT2games,
                bakerToStandardGamesRatio,
                maxEventDuration,
                tierOneGameMaxThreshold,
                totalGameMaxThreshold,
                isSeasonSet
            }
            seasonSetup[id] = setup
        })
        return seasonSetup
}

function getSingleSeasonSetup(season){
 
  
  const { id, minT1games, minT2games, bakerToStandardGamesRatio, maxEventDuration, tierOneGameMaxThreshold, totalGameMaxThreshold } = season
        const setup = {
            seasonId: id,
            minT1games,
            minT2games,
            bakerToStandardGamesRatio,
            maxEventDuration,
            tierOneGameMaxThreshold,
            totalGameMaxThreshold,
            isSeasonSet:true
        }
      
    return setup
}
       
export default function seasonsetup (state,action) {   
        const {  payload } = action      
        switch(action.type) {
          
            case FETCH_ACTIVE_SEASONS: {           
                const { data } = payload
                if (data) {                
                    const defaultId = payload.data[0].id
                    const setup = getSeasonsSetup(data)
                   
                    return Object.assign({},state,{
                            values: {
                                setup,
                                settingsseason:defaultId,
                                initialstate:setup,
                                setupreset:false,
                               // datasaved:true
                            },
                            fields: {
                                setup,
                                settingsseason:defaultId,
                                initialstate:setup,
                                setupreset:false,
                               // datasaved:true
                            }
                        }
                    )
                }
                else {
                    return state
                }
            }
            case SAVE_SEASON_SETUP: {
                const datasaved  = true 
                const savingdata = false
                return  { 
                    ...state, 
                    values: {
                             ...state.values,
                             initialstate:state.values.setup,
                             savingdata,
                             datasaved         
                           },
                    fields:{
                             ...state.fields,
                             initialstate:state.values.setup,
                             savingdata,
                             datasaved
                           }
                }
            }
            case TRIGGER_SEASON: {
                const seasontriggered = true 
                const isSettingSeason = false
              
                const seasonsetup  = getSingleSeasonSetup(payload.data)
               
                const seasonId  = seasonsetup.seasonId
                const { setup } = state.values
                setup[seasonId] = seasonsetup
               
                return  { ...state, 
                   values: {
                             ...state.values ,
                             seasontriggered,
                             isSettingSeason ,
                             setup:setup                            
                           },
                   fields: {
                             ...state.fields,
                             seasontriggered,
                             isSettingSeason,
                             setup:setup    
                           }
                 }
               
            }
            case RESET_SETUP_SETTINGS:{
             
                const { initialstate } = state.values
              
                return  { ...state, 
                    values: {
                             ...state.values,
                             setup:initialstate,
                             setupreset:true
                           },
                    fields:{
                             ...state.fields,
                             setup:initialstate,
                             setupreset:true
                           }
                 }
            }
            default: return state
        }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonsetup.js